<script>
import Layout from '../../layout/Layout'
import Menu from '../menu'
import {list, listClassificacao, listLeiloeiros, deleteLeilao} from '@/domain/leiloes/services'
import {UTable, UTh, UTr, UTd, UCheckbox, date} from 'uloc-vue'
import {
  EBtnTableOptions
} from 'uloc-vue-plugin-erp'
import StatusLeilao from './include/StatusLeilao'
import ContextMenuLeilaoItem from './context/list-context-leilao'
import MenuOptions from '../../layout/context-menu/context-window-options'
import DefaultListMenu from './context/list-menu-leilao'
import SearchFilter from '../../layout/helpers/SearchFilter'
import {ErpInput, /*ErpSelect,*/ ErpSField} from 'uloc-vue-plugin-erp'
import DefaultMixin from '../mixin'
import StatusSelect from './include/StatusLeilaoSelect'
import DateInput from '../../../reuse/input/Date'
import leilaoWindow from '../windows/leilao'
import TipoLeilaoSelect from './include/TipoLeilaoSelect'
import DefaultAsyncSelect from '../../../reuse/input/DefaultAsyncSelect'
import StatusInternoSelect from './include/StatusInternoLeilaoSelect'
import listOptions from '../windows/listOptions'
import {datePtToEn} from '@/utils/date';
import StatusInternoLeilao from './include/StatusInternoLeilao'
import tableColumnsCache from "@/utils/tableColumnsCache"
import {donwloadFile} from "@/utils/downloadFile"
import leiloesHtmlView from "@/components/relatorios/components/leiloes/leiloesHtmlView"
import ERow from "@/components/layout/components/Row"
import ECol from "@/components/layout/components/Col"

const listStorage = tableColumnsCache('leiloes.lista', [
  {label: 'ID', name: 'id', active: true, sortable: true, ordering: 1},
  {label: 'Código', name: 'codigo', active: true, sortable: true, ordering: 1},
  {label: 'Data', name: 'dataProximoLeilao', active: true, sortable: true, ordering: 1},
  {label: 'Resumo', name: 'resumo', active: true, sortable: true, ordering: 1},
  {label: 'Publicação', name: 'publicacao', active: false, sortable: true, ordering: 1},
  {label: 'Abertura', name: 'abertura', active: false, sortable: true, ordering: 1},
  {label: 'Encerramento', name: 'encerramento', active: false, sortable: true, ordering: 1},
  {label: 'Detalhes', name: 'detalhes', active: true, sortable: true, ordering: 1},
  {label: 'Status', name: 'status', active: true, sortable: true, ordering: 1},
  {label: 'Status Interno', name: 'statusInterno', active: false, sortable: true, ordering: 1}
], 1)

let filters = {
  id: null,
  descricao: null,
  codigo: null,
  tipo: null,
  classificacao: null,
  data1: null,
  data2: null,
  leiloeiro: null,
  status: [0, 1, 2, 3, 4],
  statusInterno: [],
  modulo: null
}

export default {
  name: 'Leiloes',
  mixins: [DefaultMixin],
  components: {
    StatusInternoLeilao,
    StatusInternoSelect,
    DefaultAsyncSelect,
    TipoLeilaoSelect,
    DateInput,
    StatusSelect,
    SearchFilter,
    DefaultListMenu,
    MenuOptions,
    ContextMenuLeilaoItem,
    StatusLeilao,
    Layout,
    UTable,
    UTh,
    UTr,
    UTd,
    UCheckbox,
    EBtnTableOptions,
    ErpInput,
    // ErpSelect,
    ErpSField,
    ERow,
    ECol
  },
  data() {
    return {
      listStorage: listStorage,
      listType: 'ativos',
      table: {
        busca: '',
        serverData: [],
        serverPagination: {
          page: 1,
          rowsNumber: 10, // specifying this determines pagination is server-side
          rowsPerPage: 20
        },
        columns: listStorage.map(o => {
          return {
            ...o,
            field: o.name,
            align: 'left'
          }
        }).concat([
          {
            name: 'options',
            required: true,
            label: '',
            field: 'options',
            sortable: false
          }
        ]),
        filter: '',
        filters: JSON.parse(JSON.stringify(filters)),
        selected: [],
        loading: false
      }
    }
  },
  computed: {
    menu() {
      return Menu
    },
    menuDashOptions() {
      return MenuOptions
    },
    visibledColumns() {
      return this.listStorage.filter(item => item.active).map(item => item.name)
    }
  },
  beforeMount () {
    if (this.$route.hash) {
      this.parseHash()
    } else {
      this.table.filters.modulo = null
    }
  },
  watch: {
    '$route' () {
      this.$nextTick(() => {
        if (this.parseHash()) {
          this.load()
        }
      })
    }
  },
  mounted() {
    this.load()
  },
  destroyed() {
    // document.querySelector('.u-erp-layout-container').classList.remove('bg-white')
  },
  methods: {
    parseHash () {
      if (this.$route.hash) {
        const hash = this.$route.hash.replace('#', '')
        if (hash === 'rural') {
          this.table.filters.modulo = 'rural'
          //this.load()
        }
        return true
      }
    },
    request({pagination, filter, format}) {

      let data1, data2
      let extraFilters = []

      if (this.table.filters.data1) {
        if (this.table.filters.data1.length < 10 || this.table.filters.data2.length < 10) {
          alert('Digite a data inicial e data final corretamente para o filtro de entrada.')
          return
        }

        data1 = datePtToEn(this.table.filters.data1)
        data2 = datePtToEn(this.table.filters.data2)
        if (!date.isValid(data1) || !date.isValid(data2)) {
          alert('Digite a data inicial e data final corretamente. Formato: dd/mm/yyyy')
          return
        }
        extraFilters.push(`&data1=${data1}&data2=${data2}`)
      }

      this.table.filters.id && extraFilters.push(`&id=${this.table.filters.id}`)
      this.table.filters.codigo && extraFilters.push(`&codigo=${this.table.filters.codigo}`)
      this.table.filters.ano && extraFilters.push(`&ano=${this.table.filters.ano}`)
      this.table.filters.tipo && extraFilters.push(`&tipo=${this.table.filters.tipo}`)
      this.table.filters.classificacao && extraFilters.push(`&classificacao=${this.table.filters.classificacao}`)
      this.table.filters.leiloeiro && extraFilters.push(`&leiloeiro=${this.table.filters.leiloeiro}`)
      this.table.filters.modulo && extraFilters.push(`&modulo=${this.table.filters.modulo}`)

      if (Array.isArray(this.table.filters.status) && this.table.filters.status.length > 0) {
        extraFilters.push(`&status=${this.table.filters.status.join(',')}`)
      }

      if (Array.isArray(this.table.filters.statusInterno) && this.table.filters.statusInterno.length > 0) {
        extraFilters.push(`&statusInterno=${this.table.filters.statusInterno.join(',')}`)
      }

      if (format === 'excel' || format === 'xlsx') {
        extraFilters.push('&format=excel')
      } else if(format === 'html') {
        extraFilters.push('&format=html')
      }

      this.table.loading = true
      let _filter = this.filtros
      let filtros = encodeURI(`&sortBy=${pagination.sortBy || 'dataProximoLeilao'}&descending=${pagination.sortBy ? (pagination.descending ? 'true' : 'false') : (this.listType === 'ativos' ? 'false' : true)}&search=${filter}${extraFilters.join('')}`)


      list(pagination.rowsPerPage, pagination.page, filtros, format)
          .then((response) => {
            let data = response.data
            this.loading = false
            this.table.loading = false
            if (format === 'excel' || format === 'xlsx') {
              donwloadFile(response)
              return
            } else if(format === 'html') {
              this.leiloesHtmlView(data)
              return
            }
            this.table.serverPagination = pagination
            this.table.serverPagination.rowsNumber = data.total
            let result = data.result
            if (Number(pagination.page) < 2) {
              if (data.hoje && data.hoje.length) {
                data.hoje.map(leilao => {
                  leilao.isToday = true
                  result = result.filter(l => l.id !== leilao.id)
                  result.unshift(leilao)
                })
              }
            }
            this.table.serverData = result

            this.table.loading = false
          })
          .catch(error => {
            this.alertApiError(error)
            this.table.loading = false
            this.loading = false
          })
    },
    load(format = null) {
      this.request({
        pagination: this.table.serverPagination,
        filter: this.table.busca,
        format: format
      })
    },
    clearFilters() {
      this.table.filters = JSON.parse(JSON.stringify(filters))
    },
    novo() {
      console.log('New...')
      this.leilaoWindow(null, this.table.filters.modulo)
    },
    pesquisar() {
      this.request({
        pagination: this.table.serverPagination,
        filter: this.table.filters.descricao || this.table.busca
      })
    },
    abrir(id) {
      this.$router.push({name: 'leiloes.show', params: {id: id}})
      /*let router = this.$router || this.router
      let routeData = router.resolve({name: 'leiloes.show', params: {id: id}})
      window.open(routeData.href, '_blank')*/
    },
    edit(id) {
      this.leilaoWindow(id, this.$route.query.tipo)
    },
    excluir(id) {
      this.confirmarExclusao('Tem certeza que deseja excluir este leilão? Todos os dados serão perdidos, sem possibilidade de recuperá-los.', 'excluir leilao-' + id)
          .then(() => {
            this.$uloc.loading.show()
            deleteLeilao(id)
                .then(() => {
                  this.$uloc.loading.hide()
                  this.$uloc.notify({
                    color: 'positive',
                    message: `Leilão excluído com sucesso.`
                  })
                  this.load()
                })
                .catch(error => {
                  this.$uloc.loading.hide()
                  this.alertApiError(error)
                })
          })
          .catch(() => {
          })
    },
    leilaoWindow: leilaoWindow,
    listClassificacao: listClassificacao,
    listLeiloeiros: listLeiloeiros,
    windowLeilaoEvents(wid) {
      console.log('Bind events')
      this.$uloc.window.listen(wid, {
        new: (wid, leilao) => {
          console.log('Updated event')
          // this.load()
          this.$router.push({name: 'leiloes.show', params: {id: leilao.id}})
        },
        update: (wid, leilao) => {
          console.log('Updated event')
          this.load()
        }
      })
    },
    listOptions: listOptions,
    updateListDefinition(newConfig) {
      LocalStorage.set('leiloes.lista', newConfig)
      this.listStorage = newConfig
    },
    changeListType (v) {
      this.listType = v
      if (v === 'ativos') {
        this.table.filters.status = [0, 1, 2, 3, 4]
      } else if (v === 'finalizados') {
        this.table.filters.status = [96, 97, 98, 99]
      } else {
        this.table.filters.status = []
      }
      this.load()
    },
    leiloesHtmlView: leiloesHtmlView,
    imprimir () {
      this.load('html')
    }
  },
  meta: {
    title: 'Leilões',
    name: 'Leilões'
  }
}
</script>

<template>
  <layout v-if="$route.name === 'leiloes.lista'" class="erp-list" :menu="menu" menu-style="compact" menu-active="leiloes">
    <div>
      <search-filter>
        <form id="leilaoFilter" class="m-t-sm">
          <e-row mr>

            <div class="col" style="max-width: 70px; min-width: 70px">
              <erp-s-field
                  view="tl"
                  label="ID"
              >
                <erp-input shortkey="F3" v-model="table.filters.id" @keydown.enter="pesquisar"/>
              </erp-s-field>
            </div>

            <e-col class="col" style="max-width: 90px; min-width: 90px">
              <erp-s-field
                  view="tl"
                  label="Código do Leilão"
              >
                <erp-input shortkey="F2" v-model="table.filters.codigo" @keydown.enter="pesquisar"/>
              </erp-s-field>
            </e-col>

            <e-col class="col" style="max-width: 80px; min-width: 80px">
              <erp-s-field
                  view="tl"
                  label="Ano"
              >
                <erp-input v-model="table.filters.ano" @keydown.enter="pesquisar"/>
              </erp-s-field>
            </e-col>

            <div class="col" style="min-width: 126px; max-width: 126px">
              <tipo-leilao-select v-model="table.filters.tipo"/>
            </div>

            <div class="col" style="min-width: 146px; max-width: 146px">
              <default-async-select label="Classificação" v-model="table.filters.classificacao"
                                    :list="listClassificacao"/>
            </div>

            <div class="col" style="min-width: 146px; max-width: 146px">
              <date-input label="Data (De)" v-model="table.filters.data1"/>
            </div>

            <div class="col" style="min-width: 146px; max-width: 146px">
              <date-input label="Data (Até)" v-model="table.filters.data2"/>
            </div>

            <div class="col">
              <default-async-select label="Leiloeiro" v-model="table.filters.leiloeiro" :list="listLeiloeiros"/>
            </div>


          </e-row>

          <div class="row erp-row def-m-r">

            <div class="col">
              <erp-s-field
                  view="tl"
                  label="Descrição"
              >
                <erp-input shortkey="F4" v-model="table.filters.descricao" @keydown.enter="pesquisar"/>
              </erp-s-field>
            </div>

            <div class="col">
              <status-select multiple v-model="table.filters.status"/>
            </div>

            <div class="col">
              <status-interno-select multiple v-model="table.filters.statusInterno"/>
            </div>
            <div class="col flex justify-end m-t-sm def-list-buttons" style="min-width: 300px">
              <div class="flex flex-center column m-r-xs">
                <u-btn class="pesquisar" label="Pesquisar" v-shortkey="['shift', 'enter']" @shortkey.native="pesquisar"
                       @click="pesquisar" />
                <span class="shortcut">Shift + Enter</span>
              </div>
              <div class="flex flex-center column m-r-xs">
                <u-btn @click="clearFilters" class="limpar" label="Limpar Filtros" v-shortkey="['ctrl', 'shift', 'r']"
                       @shortkey.native="clearFilters"/>
                <span class="shortcut">Ctrl + Shift + R</span>
              </div>
              <div class="flex flex-center column" v-if="cracl(null, ['sl/leilao/create'])">
                <u-btn @click="novo" class="cadastrar" label="Cadastrar" v-shortkey="['shift', 'n']"
                       @shortkey.native="novo"/>
                <span class="shortcut">Shift + N</span>
              </div>
            </div>
          </div>
        </form>
      </search-filter>
      <div class="erp-list">
        <div class="erp-list-top-btns">
          <div class="actives-btns">
            <u-btn @click="changeListType('ativos')" label="Ativos" class="active-table-btn" :class="{active: listType === 'ativos'}" no-caps />
            <u-btn @click="changeListType('finalizados')" label="Finalizados" class="text-grey active-table-btn" :class="{active: listType === 'finalizados'}" no-caps />
            <u-btn @click="changeListType('todos')" label="Todos" class="text-grey active-table-btn" :class="{active: listType === 'todos'}" no-caps />
          </div>
          <div class="end">
            <u-btn @click="imprimir" title="Imprimir" no-caps size="sm" flat icon="print" icon-type="fa" color="grey-4" class="text-grey-8" style="padding: 1px 8px"/>
            <u-btn @click="load('excel')" title="Exportar para Excel" no-caps size="sm" flat icon="file-excel" icon-type="fa" color="grey-4" class="text-grey-8 m-r-sm" style="padding: 1px 6px"/>
            <u-btn @click="listOptions" label="Configurar lista" no-caps size="sm" color="grey-4" class="text-grey-8"/>
          </div>
        </div>
        <u-table
            ref="table"
            color="primary"
            :data="table.serverData"
            :columns="table.columns"
            :visible-columns="visibledColumns"
            :filter="table.busca"
            row-key="id"
            :pagination.sync="table.serverPagination"
            @request="request"
            selection="multiple"
            :selected.sync="table.selected"
            :loading="table.loading"
            class="erp-table"
            :rows-per-page-options="[20, 50, 100]"
        >
          <!--<template slot="top-right" slot-scope="props">
          </template>-->
          <u-tr slot="header" slot-scope="props">
            <u-th auto-width>
              <u-checkbox
                  v-model="props.selected"
                  :indeterminate="props.partialSelected"
                  size="sm"
              />
            </u-th>
            <u-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </u-th>
          </u-tr>

          <u-tr v-on:dblclick.native="abrir(props.row.id)" class="cursor-pointer" slot="body" slot-scope="props"
                :props="props" :class="{'u-table-item-destac': props.row.isToday}">
            <u-td auto-width>
              <u-checkbox color="primary" v-model="props.selected" size="xs"/>
            </u-td>
            <u-td style="max-width: 40px; min-width: 40px; width: 40px" key="id" :props="props">
              {{ props.row.id }}
            </u-td>
            <u-td style="max-width: 100px; min-width: 100px; width: 100px" key="codigo" :props="props">
              {{ props.row.numero }}/{{ props.row.ano }}
            </u-td>
            <u-td style="max-width: 160px; min-width: 160px; width: 160px" class="td-limit today" key="dataProximoLeilao" :props="props">
              <span class="m-r-xs" v-if="props.row.dataProximoLeilao">{{ props.row.dataProximoLeilao.date|formatDate('dd/MM/yyyy HH:mm') }}</span>
              <span class="m-r-xs" v-else-if="props.row.dataAbertura">{{ props.row.dataAbertura.date|formatDate('dd/MM/yyyy HH:mm') }} <i class="font-10 m-l-xs">(abertura)</i> </span>
            </u-td>
            <u-td :title="props.row.resumo" class="td-limit_ l-130_" key="resumo"
                  :props="props">
              <span v-if="props.row.vendaDireta" class="badge badge-sm bg-purple text-white">Venda Direta</span> {{ props.row.descricaoInterna }}
            </u-td>
            <u-td style="max-width: 160px; min-width: 160px; width: 160px" class="td-limit" key="publicacao" :props="props">
              <div v-if="props.row.dataPublicacao">
                {{ props.row.dataPublicacao.date|formatDate('dd/MM/yyyy HH:mm') }}
              </div>
              <div v-else>Nunca</div>
            </u-td>
            <u-td style="max-width: 160px; min-width: 160px; width: 160px" class="td-limit today" key="abertura" :props="props">
              <span v-if="props.row.dataAbertura">{{ props.row.dataAbertura.date|formatDate('dd/MM/yyyy HH:mm') }}</span>
            </u-td>
            <u-td style="max-width: 160px; min-width: 160px; width: 160px" class="td-limit" key="encerramento" :props="props">
              <span
                  v-if="props.row.dataFimPraca1">{{
                  props.row.dataFimPraca1.date|formatDate('dd/MM/yyyy HH:mm')
                }}</span>
              <span v-else>-</span>
            </u-td>
            <u-td style="max-width: 100px; min-width: 100px; width: 100px" key="detalhes" :props="props">
              {{ props.row.totalLotes }} lote{{ Number(props.row.totalLotes) > 1 ? 's' : '' }}
            </u-td>
            <u-td style="max-width: 200px; min-width: 200px; width: 200px" class="text-uppercase" key="status" :props="props">
              <status-leilao :leilao="props.row"/>
            </u-td>
            <u-td style="max-width: 170px; min-width: 170px; width: 170px" class="text-uppercase" key="statusInterno" :props="props">
              <status-interno-leilao :leilao="props.row"/>
            </u-td>
            <u-td style="max-width: 70px; min-width: 70px; width: 70px" class="text-center" key="options" :props="props">
              <e-btn-table-options>
                <menu-options>
                  <default-list-menu @abrir="abrir(props.row.id)" @edit="edit(props.row.id)"
                                     @excluir="excluir(props.row.id)" :leilao="props.row"/>
                </menu-options>
              </e-btn-table-options>
            </u-td>
            <context-menu-leilao-item @abrir="abrir(props.row.id)" @edit="edit(props.row.id)"
                                      @excluir="excluir(props.row.id)" :leilao="props.row"/>
          </u-tr>
        </u-table>
      </div>
    </div>
  </layout>
  <router-view v-else />
</template>

<style lang="stylus" src="../assets/default.styl"></style>
